<template lang="pug">
div
  template
    .test-payout-block
      .tarnsfer_form
        .form-step
          dropdown-accounts(:accounts="model.options.accounts ? model.options.accounts : []" v-model="model.values.fromAccount" :allow-clear="true")
          // QiwiPaymentForm
        br
        br
        div
          select-payment-template(system="rucards")
        br
        //.form-step
          //YoomoneyPaymentForm
          //UkrainianMobilePaymentForm
          //WebmoneyPaymentForm
          RussianCardsPaymentForm
        br
        //.form-step
          Card2cardPaymentForm

        br
        .form-step
          //UsdtPaymentForm(:source-account-number="model.values.fromAccount")
          //CapitalistInternalPaymentForm(:source-account-number="model.values.fromAccount")
          // WirePaymentForm(:source-account-number="model.values.fromAccount")
          //CapitalistCardTopupPaymentForm(:source-account-number="model.values.fromAccount")
          RussianCardsPaymentForm(:source-account-number="model.values.fromAccount")
          //IMPSPaymentForm(:source-account-number="model.values.fromAccount")
          //PayTMPaymentForm(:source-account-number="model.values.fromAccount")


    br
    CompositionApiTestBlock
          //BitcoinPaymentForm
          //EthereumPaymentForm
          // SngCardsPaymentForm
          // KzCardsPaymentForm(:source-account-number="model.values.fromAccount")
          //CapitalistCardTopupPaymentForm(:source-account-number="model.values.fromAccount")
    //section.regular-form.horizontal
        .form-step
          form(role="form")
            .form-groups-container

              // horizontal-form-group
                div.elements
                  payout-hint-panel
                    walleto-kyc-reset-warning-payout-hint

              horizontal-form-group(:label="$t('Отправитель')" :required="true" :has-errors="model.errors.hasErrorsSplit('fromAccount')" )
                div.elements
                  dropdown-accounts(:disabled="formDisabled" :accounts="filteredAccounts" v-model="model.values.fromAccount")
                  // payout-date-input(v-model="testDate" init-value="2019-04" :picker-options="pickerOptions")
                template(v-if="model.errors.hasErrorsSplit('fromAccount')")
                  div
                  form-error-message-block(:errors="model.errors" attribute="phone")
                div
                div
              // horizontal-form-group(:label="$t('Получатель')" :required="true" :has-errors="model.errors.hasErrorsSplit('destAccount')" )
                div.elements
                  dropdown-accounts(:disabled="formDisabled" :accounts="filteredAccounts" v-model="model.values.destAccount")
                template(v-if="model.errors.hasErrorsSplit('destAccount')")
                  div
                  form-error-message-block(:errors="model.errors" attribute="phone")
                div
                div
                  //div.help-block
                    template {{$t('Номер в формате {num}.', {num: '+7 903 123 45 67'})}}

              // template(v-if="selectedCurrency")
                //  && !hasGeneratingAddresses

                //horizontal-form-group(:label="$t('Комиссия')" :required="false")
                  div
                    //payout-fee-estimate-block(:model="feeModel" :amount="model.values.amount" :currency="model.values.currency" ref="fee" @taxfail="onTaxFail")

                horizontal-form-group(:label="$t('Сумма')" :required="true" :has-errors="model.hasAmountErrors" )
                  div
                    .input-group
                      input(type="text" v-model="model.values.amount"  :disabled="formDisabled" :class="{disabled: formDisabled}").form-control
                      .input-addon
                        div {{selectedCurrency }}
                  //template(v-if="model.errors.hasErrorsSplit('amount')")
                    div
                    form-error-message-block(:errors="model.errors" attribute="amount")
                  div
                  div

              // payout-crypto-currency-notice-form-group(:model="model")

</template>

<script lang="ts">
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { MercuryoDepositModel } from '@/views/pages/finance/deposit/mercuryo';
import HorizontalFormGroup from '@/components/forms/horizontal/HorizontalFormGroup.vue';
import FormErrorMessageBlock from '@/components/forms/payout/ErrorMessageBlock.vue';
import PayoutHintPanel from '@/components/forms/payout/PayoutHintPanel.vue';
import DropdownKeyvalue from '@/components/forms/dropdown/DropdownKeyValue.vue';
import DropdownAccounts from '@/components/forms/dropdown/DropdownAccounts.vue';
import DropdownCryptoAddresses from '@/components/forms/dropdown/DropdownCryptoAddresses.vue';
import { formatUnixDateFilter } from '@/models/filters/datetime';
import { MoneyFormatFilter } from '@/models/filters/money';
import { TestWebapiPayoutModel } from '@/views/pages/finance/payout/payout-forms';
import WalletoKycResetWarningPayoutHint
  from "@/views/pages/global/notices/WalletoKycResetWarningPayoutHint.vue";
import PayoutDateInput from "@/components/forms/payout/forms/PayoutDateInput.vue";
import SkrillPaymentForm from "@/components/forms/payout/forms/SkrillPaymentForm.vue";
import YoomoneyPaymentForm from "@/components/forms/payout/forms/emoney/YoomoneyPaymentForm.vue";
import CapitalistCardTopupPaymentForm
  from "@/components/forms/payout/forms/capitalist/CapitalistCardTopupPaymentForm.vue";
import QiwiPaymentForm from "@/components/forms/payout/forms/emoney/QiwiPaymentForm.vue";
import UsdtPaymentForm from "@/components/forms/payout/forms/crypto/UsdtPaymentForm.vue";
import UsdcPaymentForm from "@/components/forms/payout/forms/crypto/UsdcPaymentForm.vue";
import SngCardsPaymentForm from "@/components/forms/payout/forms/cards/SngCardsPaymentForm.vue";
import KzCardsPaymentForm from "@/components/forms/payout/forms/cards/KzCardsPaymentForm.vue";
import BitcoinPaymentForm from "@/components/forms/payout/forms/crypto/BitcoinPaymentForm.vue";
import EthereumPaymentForm from "@/components/forms/payout/forms/crypto/EthereumPaymentForm.vue";
import MtsPaymentForm from "@/components/forms/payout/forms/mobile/MtsPaymentForm.vue";
import UkrainianMobilePaymentForm
  from "@/components/forms/payout/forms/mobile/UkrainianMobilePaymentForm.vue";
import CapitalistChequePaymentForm
  from "@/components/forms/payout/forms/capitalist/CapitalistChequePaymentForm.vue";
import WebmoneyPaymentForm from "@/components/forms/payout/forms/emoney/WebmoneyPaymentForm.vue";
import RussianCardsPaymentForm
  from "@/components/forms/payout/forms/cards/RussianCardsPaymentForm.vue";
import CompositionApiTestBlock from "@/views/pages/test/CompositionApiTestBlock.vue";
import Card2cardPaymentForm from "@/components/forms/payout/forms/cards/Card2cardPaymentForm.vue";
import WorldcardsPaymentForm from "@/components/forms/payout/forms/cards/worldcards/WorldcardsPaymentForm.vue";
import UkrainianCardsPaymentForm
  from "@/components/forms/payout/forms/cards/UkrainianCardsPaymentForm.vue";
import CapitalistInternalPaymentForm
  from "@/components/forms/payout/forms/capitalist/CapitalistInternalPaymentForm.vue";
import WirePaymentForm from "@/components/forms/payout/forms/wire/WirePaymentForm.vue";
import SelectPaymentTemplate from "@/components/forms/payout/legacy/SelectPaymentTemplate.vue";
import PayTMPaymentForm from "@/components/forms/payout/forms/PayTMPaymentForm.vue";
import IMPSPaymentForm from "@/components/forms/payout/forms/IMPSPaymentForm.vue";




@Component({
  name: 'test-payout-block',
  components: {
    IMPSPaymentForm,
    PayTMPaymentForm,
    SelectPaymentTemplate,
    WirePaymentForm,
    CapitalistInternalPaymentForm,
    UkrainianCardsPaymentForm,
    WorldcardsPaymentForm,
    Card2cardPaymentForm,
    CompositionApiTestBlock,
    RussianCardsPaymentForm,
    WebmoneyPaymentForm,
    CapitalistChequePaymentForm,
    UkrainianMobilePaymentForm,
    MtsPaymentForm,
    EthereumPaymentForm,
    BitcoinPaymentForm,
    KzCardsPaymentForm,
    SngCardsPaymentForm,
    UsdcPaymentForm,
    UsdtPaymentForm,
    QiwiPaymentForm,
    CapitalistCardTopupPaymentForm,
    YoomoneyPaymentForm,
    SkrillPaymentForm,
    PayoutDateInput,
    DropdownCryptoAddresses,
    WalletoKycResetWarningPayoutHint,
    DropdownAccounts,
    DropdownKeyvalue,
    PayoutHintPanel,
    FormErrorMessageBlock,
    HorizontalFormGroup,
  },
  filters: {
    tsFormat: formatUnixDateFilter,
    moneyFormat: MoneyFormatFilter,
  },
})
export default class TestPayoutFormBlock extends Vue {
  model: TestWebapiPayoutModel = new TestWebapiPayoutModel();

  testDate = '2020-01'

  get pickerOptions() {
    return {
      range: false,
      dateFormat: 'yyyy-MM',
      minDate: new Date(),
      maxDate: new Date(2030, 0, 0),
      view: 'years', minView: 'months',
      autoClose: true,
      language: 'ru', //document.getElementsByTagName("html")[0].getAttribute("lang")
    };
  }

  selectCurrency(currency: string) {
    for (const account of this.filteredAccounts) {
      if (account.currency === currency) this.model.values.fromAccount = account.number;
    }
  }

  get selectedCurrency() {
    return this.model.loadingModel.isLoaded && this.selectedAccount
      ? this.selectedAccount.currency : null;
  }

  get selectedAccount() {
    for (const a of this.filteredAccounts) {
      if (a.number === this.model.values.fromAccount) return a;
    }
    return null;
  }

  get formDisabled(): boolean {
    return !this.model.loadingModel.isLoaded;
  }

  mounted() {
    this.model.loadModel('kzcards');
  }

  get filteredAccounts() {
    return this.model.loadingModel.isLoaded
      ? this.model.options.accounts : [];
  }
}
</script>

<style scoped lang="less">
@import "../../../../less-mixins/legacy-flexbox-mixins";
@import "../../../../less-mixins/legacy-mixins";

.input-group {
  display: grid;
  grid-template-columns: auto max-content;

  .input-addon {
    cursor: pointer;
    .flex-display(flex);
    .align-items(center);
    .justify-content(center);

    text-align: center;
    background: #80bd1c;
    color: #fff;
    line-height: 14px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: 0;
  }

  .input-addon::v-deep {
    color: #fff;
    padding: 0 15px;
    /*.dropdown {
      button {
        background: none;
        color: #fff;
        border: none;
        box-shadow: none;
        .box-shadow(none);
      }

      .dropdown_selected {
        margin-right: 25px;
      }
    }

    [data-toggle="dropdown"]:after {

      border-color: #fff transparent transparent transparent;
    }*/
  }
}

.mercuryo-deposit-block {
  padding: 0 150px 1em 0;
  margin-top: 1.5em;
}
.my-hint-block {
  .hint-panel-question-icon {
    color: #5c8f08;
    line-height: 1.4em;
    &.warning-icon {
      color: #eea236;
    }
  }

  //.panel-heading {
  //  margin-bottom: 0;
  //  padding-bottom: 0;
  //}
}

.red {
  color: red;
}

.no-wrap {
  white-space: nowrap;
}

.alert {
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
}
</style>

<i18n>
{
  "en": {
    "title": "Deposit Capitalist.net account via Visa/Mastercard",
    "Получатель": "Beneficiary",
    "Адрес для пополнения": "Deposit address",
    "К оплате": "Next",
    "Платеж через партнера": "Payment via {partner_site}",
    "Подождите, генерируются адреса, необходимые для пополнения...": "Please wait while generating crypto addresses...",
    "hint_text": "You will be redirected to {partner_site} to complete your payment.",
    "Пополнение Ethereum": "Deposit Ethereum",
    "Пополнение Bitcoin": "Deposit Bitcoin",
    "Пополнение Ethereum счета": "Deposit Ethereum",
    "Пополнение Bitcoin счета": "Deposit Bitcoin",
    "six_confirmations_bitcoin": "After receiving six network confirmations, the funds will be credited to your account.",
    "six_confirmations_ethereum": "After receiving six network confirmations, the funds will be credited to your account.",
    "ethereum_min": "Minimum deposit amount is 0.1 ETH. Smaller amount transactions will not be deposited on your Capitalist account.",
    "ethereum_min_eth": "Minimum deposit amount is {min}. Smaller amount transactions will not be deposited on your Capitalist account.",
    "min_hint": "Minimum deposit amount: {min} {cur}.",
    "Сумма": "Amount"
  },
  "ru": {
    "Платеж через партнера": "Платеж через {partner_site}",
    "title": "Пополнение счета Capitalist.net с банковской карты Visa/Mastercard",
    "hint_text": "Для завершения платежа вы будете автоматически перенаправлены на страницу оплаты.",
    "six_confirmations_bitcoin": "После получения шести подтверждений сети средства будут зачислены на ваш счет.",
    "six_confirmations_ethereum": "После получения шести подтверждений сети средства будут зачислены на ваш счет.",
    "ethereum_min": "Минимальная сумма пополнения для переводов Ethereum: 0.1 ETH. В случае отправки перевода на сумму менее 0.1 ETH средства не будут зачислены на счет Capitalist.",
    "ethereum_min_eth": "Минимальная сумма пополнения для переводов Ethereum: {min}. В случае отправки перевода на сумму менее {min} средства не будут зачислены на счет Capitalist.",
    "min_hint": "Минимальная сумма пополнения: {min} {cur}."
  }
}
</i18n>
